import { useState, useEffect } from "react";
import styles from "./filter.module.css";
import { ArrowRight, Filter, Grid, List, Search } from "react-feather";
import { Autocomplete, TextField } from "@mui/material";
import { Link } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";

const STATUS_OPTIONS = [
    { value: 0, label: "Not Verified" },
    { value: 1, label: "Verified" },
    { value: 2, label: "Not Signed" },
    { value: 3, label: "Tenant Signed" },
    { value: 4, label: "Signed" },
    { value: 5, label: "Expire Soon" },
    { value: 6, label: "Expired" },
    { value: 7, label: "Archived" },
];

const LeaseFilter = ({ handleView, isGridView, filterData, setFilterData, setPage }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [filterOpen, setFilterOpen] = useState(false);
    const [propertyList, setPropertyList] = useState([]);

    useEffect(() => {
        async function getProperties() {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_PAYMENT_API_URL + "v1/property-list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setPropertyList(response.data?.data || []);

                if (localStorage.getItem("leaseStatusyFilterData")) {
                    let statusFilter = localStorage.getItem("leaseStatusyFilterData");
                    localStorage.removeItem("leaseStatusyFilterData");

                    setFilterData(prev => { return { ...prev, status: statusFilter } });
                }
            }).catch((error) => { });
        }
        getProperties();
    }, [getAccessTokenSilently]);

    // Derived from the selected property so the list and grid view filters (two instances) stay in sync
    const apartmentList = propertyList.find((i) => i.value === filterData?.property)?.apartments || [];

    return (<div className={`${styles.SearchFilterSec}`}>
        <div className={`${styles.SearchCon}`}>
            <div className={`${styles.SearchConSec}`}>
                <Search />
                <input type="text" placeholder="Search" value={filterData?.searchKey} onChange={(e) => {
                    setFilterData((prev) => { return { ...prev, searchKey: e.target.value }; });
                    if (setPage) setPage(0);
                }} />
            </div>
        </div>

        <div className={`${styles.FilterSec}`}>
            <div className={filterOpen ? `${styles.FilterFieldSec} ${styles.Open}` : `${styles.FilterFieldSec}`}>
                <p className={`${styles.FilterTitle}`}>
                    Filters
                    <span onClick={(e) => setFilterOpen(false)}><ArrowRight /></span>
                </p>
                {/* Property */}
                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width220} CusSelectFilter Filter Autocomplete`}>
                    <Autocomplete
                        fullWidth
                        options={propertyList || []}
                        value={propertyList.find(item => item?.value === filterData?.property) || null}
                        getOptionLabel={(option) => option?.label || ""}
                        isOptionEqualToValue={(option, value) => option?.value === value?.value}
                        onChange={(event, newValue) => {
                            setFilterData(prev => ({ ...prev, property: newValue?.value || "", apartment: "" }));
                        }}
                        renderInput={(params) => (<TextField {...params} label="Property" />)}
                    />
                </div>

                {/* Apartment */}
                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter Autocomplete`}>
                    <Autocomplete
                        fullWidth
                        options={apartmentList || []}
                        value={apartmentList.find(item => item?.value === filterData?.apartment) || null}
                        getOptionLabel={(option) => option?.label || ""}
                        isOptionEqualToValue={(option, value) => option?.value === value?.value}
                        noOptionsText={!filterData?.property ? "Select Property First" : "No options"}
                        onChange={(event, newValue) => {
                            setFilterData(prev => ({ ...prev, apartment: newValue?.value || "" }));
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Apartment"
                                placeholder={apartmentList.length === 0 ? "Select Property First" : "Search apartment"}
                            />
                        )}
                    />
                </div>

                {/* Lease Status (value 0 is valid, so don't use || "" here) */}
                <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter Autocomplete`}>
                    <Autocomplete
                        fullWidth
                        options={STATUS_OPTIONS}
                        value={STATUS_OPTIONS.find(item => filterData?.status !== "" && String(item.value) === String(filterData?.status)) || null}
                        getOptionLabel={(option) => option?.label || ""}
                        isOptionEqualToValue={(option, value) => option?.value === value?.value}
                        onChange={(event, newValue) => {
                            setFilterData(prev => ({ ...prev, status: newValue ? newValue.value : "" }));
                        }}
                        renderInput={(params) => (<TextField {...params} label="Lease Status" />)}
                    />
                </div>
            </div>
            <div className={`${styles.ListGridBUCard}`}>
                {isGridView ? <div className={`${styles.ListGridBUSec}`}>
                    <div className={`${styles.ListGridBU} `} onClick={() => handleView("list")}>
                        <List /> <span>List</span>
                    </div>
                    <div className={`${styles.ListGridBU} ${styles.Active}`}>
                        <Grid /> <span>Grid</span>
                    </div>
                </div> : <div className={`${styles.ListGridBUSec}`}>
                    <div className={`${styles.ListGridBU}  ${styles.Active}`}>
                        <List /> <span>List</span>
                    </div>
                    <div className={`${styles.ListGridBU}`} onClick={() => handleView("grid")}>
                        <Grid /> <span>Grid</span>
                    </div>
                </div>}
            </div>
            <Link className={`${styles.FilterBu}`} onClick={(e) => setFilterOpen(true)}>
                <Filter />
            </Link>
        </div>
    </div>)
}

export default LeaseFilter;